import type { ReportDetailResponse, ReportListResponse } from '../types/report.js';
import { request } from './api.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business レポートストア API クライアント。スポット分析レポートの一覧・詳細・削除を行う。
 * @graph-connects /reports [calls] レポート CRUD endpoints
 */
export const reportApi = {
  list: (category?: string): Promise<ReportListResponse> => {
    const query = category ? `?category=${encodeURIComponent(category)}` : '';
    return request<ReportListResponse>(`/reports${query}`);
  },
  get: (id: string): Promise<ReportDetailResponse> =>
    request<ReportDetailResponse>(`/reports/${encodeURIComponent(id)}`),
  delete: (id: string): Promise<{ success: boolean }> =>
    request<{ success: boolean }>(`/reports/${encodeURIComponent(id)}`, { method: 'DELETE' }),
};
